import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function RangeCheckInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1 }}>
          <FieldLabel>Min (inclusive)</FieldLabel>
          <TextInput mono value={c.min ?? ''} onChange={(v) => u({ min: v })} placeholder="−∞" />
        </div>
        <div style={{ flex: 1 }}>
          <FieldLabel>Max (inclusive)</FieldLabel>
          <TextInput mono value={c.max ?? ''} onChange={(v) => u({ max: v })} placeholder="+∞" />
        </div>
      </div>
      <FieldLabel>Action on out-of-range</FieldLabel>
      <Segmented
        value={c.action || 'drop'}
        onChange={(v) => u({ action: v })}
        options={[
          { value: 'drop', label: 'Drop row' },
          { value: 'flag', label: 'Flag _valid' },
          { value: 'clip', label: 'Clip to bounds' },
        ]}
      />
      {c.action === 'flag' && (
        <>
          <FieldLabel hint={`Blank keeps the default name, ${c.column || 'col'}_valid`}>Output column</FieldLabel>
          <TextInput mono value={c.target || ''} onChange={(v) => u({ target: v })} placeholder={`${c.column || 'col'}_valid`} />
        </>
      )}
    </div>
  );
}
